import React, { useEffect, useState } from "react";
import CanvasJSReact from "../../../../../../../lib/canvasjs/canvasjs.react";
import commaNumber from "comma-number";
import Loader from "../../../../../../settings/loader";
import "./style.scss";

const CanvasJS = CanvasJSReact.CanvasJS;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJS.addColorSet("pieChart1", [
  "#E3B029",
  "#8F2DFB",
  "#29D1E3",
  "#90FA39",
  "#E39F29",
  "#FB502D",
  "#E3B029",
  "#90FA39",
  "#29E3C6",
  "#494CFF",
  "#B36F69",
  "#F7FFC9",
  "#FFB7B0",
  "#789FCC",
  "#7290B3",
  "#5DB363",
  "#C9B8FF",
  "#9EFFA5",
  "#CC986A",
  "#B38A66",
  "#ab6120",
  "#ab2220",
  "#9bab20",
  "#2037ab",
  "#ab208d",
  "#de7e7e",
  "#7ede90",
  "#ac7ede",
  "#de7eb4",
  "#3efb2d",
  "#fb2d2d",
  "#eb4034",
  "#ebb434",
  "#eb3483",
  "#56eb34",
  "#eb34e2",
  "#34eb40",
  "#9c34eb",
  "#34eb71",
  "#b134eb",
  "#34ebc9",
  "#7434eb",
  "#c334eb",
]);

function Slider2(props) {
  const [data, setData] = useState({
    result: null,
    chart: [],
  });
  const [load, setLoad] = useState(0);

  // Initialize data when props.data.state changes
  useEffect(() => {
    if (props.data.state && load === 0) {
      setData((prev) => ({
        ...prev,
        result: props.data,
      }));
      setLoad(1);
    }
    // eslint-disable-next-line
  }, [props.data.state, load]);

  // Load chart data when initialized
  useEffect(() => {
    if (props.data.state && load === 1 && data.result) {
      const chartData = data.result.revCent.data
        .map((revCent) => {
          const totalSales = data.result.sales.data
            .filter((sale) => sale.revCent === revCent.name)
            .map((sale) => sale.total);

          let total = 0;
          if (totalSales.length) {
            total = totalSales.reduce((a, b) => a + b, 0);
          }

          return {
            y: total,
            name: revCent.name,
          };
        })
        .filter((d) => d.y);

      setData((prev) => ({
        ...prev,
        chart: chartData,
      }));
      setLoad(2);
    }
    // eslint-disable-next-line
  }, [load, props.data, data.result]);

  // Export logic
  useEffect(() => {
    if (props.export) {
      props.getData({
        type: "image",
        title: "Revenue Centers",
        filter: {
          brands: props.filter.data.brands.map((brand) => brand.name),
          chains: props.filter.data.chains.map((chain) => chain.name),
          revCent: props.filter.data.revCent.map((revCent) => revCent.name),
          payType: props.filter.data.payType.map((payType) => payType.name),
          date: {
            start: props.filter.data.date.start,
            end: props.filter.data.date.end,
          },
        },
        body: {
          table: [
            {
              head: [["Revenue Center", "Total"]],
              body: data.chart.map((d) => [
                d.name,
                `${props.data.currency.base?.toUpperCase()} ${commaNumber(
                  d.y.toFixed(2)
                )}`,
              ]),
            },
          ],
          id: "exportPdf_Slide1",
        },
      });
    }
    // eslint-disable-next-line
  }, [props.export]);

  const options = {
    colorSet: "pieChart1",
    legend: {
      cursor: "pointer",
    },
    data: [
      {
        type: "pie",
        showInLegend: true,
        indexLabel: "{name}: {y}",
        yValueFormatString: `${props.data.currency.base?.toUpperCase()} #,##0.00`,
        dataPoints: data.chart,
      },
    ],
  };

  return (
    <div id={"exportPdf_Slide1"}>
      {load < 2 ? <Loader /> : <CanvasJSChart options={options} />}
    </div>
  );
}

export default Slider2;
